import api from './client'

// Серверное (персистентное) уведомление. type совпадает с фронтовым union
// в NotificationContext, поэтому маппинг тривиальный.
export interface ServerNotification {
	id: number
	type: 'bonus' | 'topup' | 'info' | 'promo'
	text: string
	/** Куда ведёт клик (путь на сайте, 10.09): документ по ссылке, работа помощника; null — просто текст. */
	url?: string | null
	read: boolean
	created_at: string | null
}

export async function getNotifications(limit = 50): Promise<{ notifications: ServerNotification[]; unread_count: number }> {
	return api.request(`/api/v1/notifications?limit=${limit}`)
}

export async function markNotificationsRead(): Promise<{ ok: boolean; marked: number }> {
	return api.request('/api/v1/notifications/read', { method: 'POST' })
}
